import {
  IUser,
  IUserMiniWithRole,
  TSchoolDelegatedRole,
  TNvRoleTypeSchool,
} from '../../../typings/interfaces/user.interface';
import { IM_USER_CONSTANTS } from './../im-user';
import { ImUserCore } from './im-user-core';
export class ImUserSchool extends ImUserCore {
  isSchoolUser(user: IUser): boolean {
    const role = this.getRoleType(user, 'school');
    return IM_USER_CONSTANTS.SCHOOL_ROLES.includes(role);
  }

  // Decide if user has school roles or cluster school roles
  isSchoolClusterOrDelegatedAdmin(user: IUser): boolean {
    const role = this.getRoleTypeOnAllLevels(user, 'school');
    return IM_USER_CONSTANTS.SCHOOL_CLUSTER_OR_DELEGATED_ADMIN.includes(role);
  }

  // Decide if user has school 'edit_all' roles
  isSchoolWideEditor(user: IUser): boolean {
    const {
      nvRole: { type },
      delegatedRole,
    } = user;
    const school_schoolWideEditor = type === 'school' && delegatedRole === 'edit_all';
    return school_schoolWideEditor;
  }

  getPrimarySchool(user: IUser): string {
    return (user.nvRole && user.nvRole.schoolId) || null;
  }

  // Decide if user can access NV sync
  canAccessSync(user: IUser): boolean {
    const isAdmin = this.isSchoolClusterOrDelegatedAdmin(user);
    return isAdmin;
  }

  // Decide if cluster user can acccess network settings (i.e. school cluster user permissions)
  canViewSchoolNetworkSettings(user: IUser | IUserMiniWithRole): boolean {
    const {
      nvRole: { type },
      canManageUsers,
    } = user;
    const roleMet = type === 'cluster_admin' || type === 'cluster';
    return roleMet && canManageUsers;
  }

  // Decide if cluster user has at least one school to view or edit
  static checkSchoolPortfolioAccess(user: IUser): boolean {
    const imUser = new this();
    const role = imUser.getRoleType(user);
    if (role === 'cluster_admin') {
      return true;
    }
    if (role === 'network_and_school') {
      if (user.portfolio && user.portfolio.permissions) {
        const permissions = user.portfolio.permissions;
        const clusterWideAccess = permissions.cluster_edit_all || permissions.cluster_view_all;
        return clusterWideAccess || (!!permissions.edit_all.length || !!permissions.view_all.length);
      }
    }
    // if network_and_school user does not have any schools that are editable or viewable
    // returns false
    return false;
  }

  // Decide if cluster user can access student lvl from mid lvl in school net dash view
  // only allows school cluster admin and full portfolio school cluster user to access student level
  // used in: network.route.ts and network-mid-level.component.ts
  canSeeSchoolNetworkStuLvl(user: IUser): boolean {
    const role = this.getRoleType(user);
    if (role === 'cluster_admin') {
      return true;
    }
    if (role === 'network_and_school') {
      return user._role_fullPortfolio;
    }
    return false;
  }

  // Decide if cluster user can manage users
  static checkSchoolClusterUserManageStatus(user: IUser): boolean {
    return user.canManageUsers;
  }
}
